import services from "../../http/index";

export const ActionDoUpdateUser = (context, payload) => {
    console.log(context);
    return services.api.request({
        url: `user/${payload.user_id}`,
        method: "put",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionListAvailabilities = (context, userId) => {
    return services.api.request({
        url: `professionals/${userId}/availability`,
        method: "get"
    }).then(response => {
        return response.data;
    });
};

export const ActionAddAvailability = (context, payload) => {
    return services.api.request({
        url: `professionals/${payload.user_id}/availability`,
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionUpdateAvailability = (context, payload) => {
    return services.api.request({
        url: `professionals/availability/${payload.id}`,
        method: "put",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionDeleteAvailability = (context, id) => {
    return services.api.request({
        url: `professionals/availability/${id}`,
        method: "delete"
    }).then(response => {
        return response.data;
    });
};

// Google Calendar Integration Actions
export const ActionConnectGoogle = (context, authCode) => {
    return services.api.request({
        url: "google/auth",
        method: "post",
        data: { code: authCode }
    }).then(response => {
        return response.data;
    });
};

export const ActionListGoogleCalendars = () => {
    return services.api.request({
        url: "google/calendars",
        method: "get"
    }).then(response => {
        return response.data;
    });
};

export const ActionCreateGoogleCalendar = (context, name) => {
    return services.api.request({
        url: "google/calendars",
        method: "post",
        data: { name }
    }).then(response => {
        return response.data;
    });
};

export const ActionSyncGoogleEvents = (context, payload) => {
    return services.api.request({
        url: "google/sync",
        method: "post",
        data: payload
    }).then(response => {
        return response.data;
    });
};

export const ActionSyncSingleEvent = (context, payload) => {
    return services.api.request({
        url: `google/events/${payload.id}/sync`,
        method: "post"
    }).then(response => {
        return response.data;
    });
};

export const ActionDisconnectGoogle = () => {
    return services.api.request({
        url: "google/disconnect",
        method: "delete"
    }).then(response => {
        return response.data;
    });
};

// WhatsApp Integration Actions
export const ActionConnectWhatsapp = () => {
    return services.api.request({
        url: "whatsapp/connect",
        method: "post"
    }).then(response => {
        return response.data;
    });
};

export const ActionCheckWhatsappStatus = () => {
    return services.api.request({
        url: "whatsapp/status",
        method: "get"
    }).then(response => {
        return response.data;
    });
};

export const ActionDisconnectWhatsapp = () => {
    return services.api.request({
        url: "whatsapp/disconnect",
        method: "post"
    }).then(response => {
        return response.data;
    });
};

// Actions para validação de limites de perfil
export const ActionGetCustomersCount = () => {
    return services.api.request({
        url: "customers",
        method: "get"
    }).then(response => {
        return {
            count: response.data.length,
            customers: response.data
        };
    });
};

export const ActionGetMonthlySessionsCount = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const dateFrom = firstDay.toISOString().split('T')[0];
    
    return services.api.request({
        url: "sessions",
        method: "get",
        params: { date_from: dateFrom }
    }).then(response => {
        return {
            count: response.data.length,
            sessions: response.data
        };
    });
};

export const ActionGetActiveContractsCount = (context, customerId) => {
    return services.api.request({
        url: `customers/${customerId}/contracts`,
        method: "get"
    }).then(response => {
        const activeContracts = response.data.filter(c => c.status === 'A');
        return {
            count: activeContracts.length,
            contracts: activeContracts
        };
    });
};